import axios from "axios";

/**
 * Inscribe a un estudiante en una practica.
 * @param {string} userId ID del estudiante.
 * @param {string} simulacrumsId ID del simulacro.
 * @return {Object} Respuesta.
 */
export async function enrollToSimulacrum(simulacrumsId, courseId) {
  return axios
    .post(`${import.meta.env.VITE_API_BASE_URL}/api/simulacrums/enroll`, {simulacrum: simulacrumsId, module: courseId})
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getStudentStatusSimulacrum(courseId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/simulacrums/getStudentStatus`, {
      params: { moduleId: courseId}
    })
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getSimulacrum(simulacrumId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/simulacrums/exercise/${simulacrumId}`)
    .then((response) => response.data)
    .catch((err) => console.error(err));
}

export async function getExercises(simulacrumId) {
  return axios
    .get(`${import.meta.env.VITE_API_BASE_URL}/api/simulacrums/${simulacrumId}/exercises`)
    .then((response) => response.data)
    .catch((err) => console.error(err));
}
